import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { ApiConfiguration } from './api-configuration';
import { Observable as __Observable, throwError, from, forkJoin } from 'rxjs';
import { map as __map, filter as __filter, catchError, retry } from 'rxjs/operators';
import { AuthenticationCheckService } from '../auth/authentication-check.service';

const httpOptions = {
  headers : new HttpHeaders({'Content-Type': 'application/json'}),
  observe: 'response' as 'response'
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  authToken;
  constructor(private httpClient: HttpClient, protected config: ApiConfiguration,private auth:AuthenticationCheckService) {
    this.authToken= auth.getAuthToken();
  }


  // Adds program_id from login-details to every request.
  private attachProgramId(url: string, data?: any): { url: string, data: any } {
    const programId = this.getProgramId();
    let nextUrl = url;
    if (programId && url.indexOf('program_id=') === -1) {
      nextUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'program_id=' + encodeURIComponent(programId);
    }

    let nextData = data;
    if (programId && data instanceof FormData) {
      if (!data.get('program_id')) {
        data.append('program_id', programId);
      }
    } else if (programId && data && typeof data === 'object' && !data.program_id) {
      nextData = Object.assign({}, data, { program_id: programId });
    }

    return { url: nextUrl, data: nextData };
  }

  private getProgramId(): string {
    try {
      const raw = localStorage.getItem('login-details');
      if (!raw) {
        return '';
      }
      const details = JSON.parse(raw);
      const programId = details && (details.program_id || details.programId);
      return programId ? String(programId) : '';
    } catch (e) {
      return '';
    }
  }

  // Get details from server
  public get(url: any): __Observable<[]> {
    const request = this.attachProgramId(url);
    return this.httpClient.get<any>(request.url, {responseType: 'json'})
    .pipe(
      catchError(this.handleError)
      )
  }

  public getHeaders(url: any): __Observable<any> {
    const request = this.attachProgramId(url);
    return this.httpClient.get<any>(request.url, { observe: 'response' });
  }

  public getFullResponse(url: any): __Observable<any> {
    const request = this.attachProgramId(url);
    return this.httpClient.get<any>(request.url, { observe: 'response' }).pipe(catchError(this.handleError))
  }

  // post details to server
  public post(url,data:any):__Observable<any>{
    const request = this.attachProgramId(url, data);
    return this.httpClient.post<any>(request.url, request.data,httpOptions).pipe(catchError(this.handleError))
  }

  // put details to server
  public put(url,data:any):__Observable<any>{
    const request = this.attachProgramId(url, data);
    return this.httpClient.put<any>(request.url, request.data,httpOptions).pipe(catchError(this.handleError))
  }

  // put details to server
  public delete(url,data:any):__Observable<any>{
    const request = this.attachProgramId(url, data);
    return this.httpClient.delete<any>(request.url, request.data).pipe(catchError(this.handleError))
  }

  public postFullResponse(url: any, data:any): __Observable<any> {
    const request = this.attachProgramId(url, data);
    let headers = { 'Content-Type':'application/json' };
    return this.httpClient.post<any>(request.url, request.data, { headers, observe: 'response' }).pipe(catchError(this.handleError))
  }

  public postWithFormData(url,data:any):__Observable<any>{
    const request = this.attachProgramId(url, data);
    let headers = { 'Content-Type':'application/json' };
    return this.httpClient.post<any>(request.url, request.data, {headers,responseType: 'json'}).pipe(catchError(this.handleError))
  }

  public postWithFormDataNew(url,data:any):__Observable<any> {
    const request = this.attachProgramId(url, data);
    let headers = { 'Content-Type':'multipart/form-data' };
    return this.httpClient.post<any>(request.url, request.data, { headers }).pipe(catchError(this.handleError));
    //return this.httpClient.post(url, data).map((response: Response) => { return response; }).catch(this.handleError);
  }

  // Post with Progress report
  public upload(url,sendFile):__Observable<HttpEvent<any>>{
  //  {reportProgress: true,observe: 'events',responseType: 'json',headers:{skip:"true",'Content-type':'undefined'}}
    const request = this.attachProgramId(url, sendFile);
    return this.httpClient.post<any>(request.url, request.data,{reportProgress: true,observe: 'events',headers:{skip:"true"}}).pipe(catchError(this.handleError))
  }

  public upload_with_loader(url,sendFile):__Observable<HttpEvent<any>>{
    //  {reportProgress: true,observe: 'events',responseType: 'json',headers:{skip:"true",'Content-type':'undefined'}}
      const request = this.attachProgramId(url, sendFile);
      return this.httpClient.post<any>(request.url, request.data,{reportProgress: true,observe: 'events'}).pipe(catchError(this.handleError))
  }
  public multiple_api_call(urls):__Observable<any>{
    return forkJoin(urls);
  }
  // download file from server
  // public downloadFile(url,data:any):__Observable<any>{
  //   const headers = {
  //     headers : new HttpHeaders({'Content-Type': 'application/json'})
  //   }
  //   return this.httpClient.get<any>(url,{responseType: 'json'}).pipe(catchError(this.handleError))
  // }

  // Error handling
  private handleError(response: any) {
    return throwError(response.error);
  }
}
